import { Observer } from 'mobx-react-lite';
import React from 'react';
import { ProjectMetaInfoWithQueriedResources } from '../../types/app.types';
import joinClassName from '../../utils/className.utils';
import { getEntryPagePath } from '../../utils/entry.utils';
import { AnimatedLink } from '../AnimatedLink/AnimatedLink';
import CTAButton from '../CTAButton/CTAButton';
import EntryMetaInfoHeader from '../EntryMetaInfoHeader/EntryMetaInfoHeader';
import GatsbyImageAdaptor from '../GatsbyImageAdaptor/GatsbyImageAdaptor';
import ProjectURLButton from '../ProjectURLButton/ProjectURLButton';
import SimpleEntryGallery from '../SimpleEntryGallery/SimpleEntryGallery';
import StandardTextBlock from '../StandardTextBlock/StandardTextBlock';
import Widowless from '../Widowless/Widowless';
import './ProjectEntry.scss';

type ProjectEntryProps = {
  project: ProjectMetaInfoWithQueriedResources,
}

const ProjectEntry: React.FC<ProjectEntryProps> = props => {
  return <Observer children={() => {
    const commonAttr = {
      className: 'ProjectEntryDefaultGallery',
      children: <>
        {
          props.project.gallery && <SimpleEntryGallery
            entry={props.project}
            range={[0, 1]}
            doNotRenderContainer
          />
        }
        {/* {(!props.project.gallery || props.project.gallery.length === 0) && <div />} */}
        {
          (!props.project.gallery || props.project.gallery.length === 0) && props.project.featuredImage && <GatsbyImageAdaptor
            image={props.project.featuredImage}
            title={props.project.featuredImage?.title ?? props.project.displayName ?? (props.project.displayName + 'Featured Image')}
            alt={props.project.featuredImage?.alt ?? (props.project.displayName + 'Featured Image')}
          />
        }
      </>
    };
    const gallery = props.project.hasPage ? <AnimatedLink
      to={getEntryPagePath(props.project)}
      title={props.project.displayName}
      {...commonAttr}
    /> : <div {...commonAttr} />
    // const gallery = <div {...commonAttr} />
    return <div className={joinClassName("ProjectEntry", !props.project.entryRenderer && 'default')}>
      {
        props.project.entryRenderer ? <props.project.entryRenderer /> : <>
          <header className="ProjectEntryDefaultHeader">
            <EntryMetaInfoHeader entry={props.project} />
            <StandardTextBlock className="ProjectEntryDefaultDescription">
              <Widowless>{props.project.description}</Widowless>
            </StandardTextBlock>
            <div className="ProjectEntryDefaultButtonRow">
              {props.project.hasPage && <CTAButton
                outlined
                to={getEntryPagePath(props.project)}
                title={props.project.displayName}
              >View Details</CTAButton>}
              {props.project.url && <ProjectURLButton project={props.project} outlined drawLine={false}/>}
            </div>
          </header>
          { gallery }
        </>
      }
    </div>
  }} />
}

export default ProjectEntry;